import React, { useState, useEffect } from 'react';
import { trackVisit } from '../utils/tracking';
import { Link } from 'react-router-dom';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL || '';

export default function Careers() {
  const [jobs, setJobs] = useState(null);
  const [b, setB] = useState({ company_name: 'Samaritan Solar', headline: 'Build the future of solar sales.', tagline: '', primary_color: '#10b981', logo_url: '', hero_image_url: '', photos: [] });

  useEffect(() => {
    trackVisit({ page: 'careers' });
    axios.get(`${API_URL}/api/careers`).then(r => setJobs(r.data.jobs)).catch(() => setJobs([]));
    axios.get(`${API_URL}/api/careers/branding`).then(r => setB(r.data)).catch(() => {});
  }, []);

  const color = b.primary_color || '#F5B301';

  return (
    <div className="min-h-screen bg-slate-950 text-white" data-testid="careers-page">
      <header className="border-b border-slate-800 sticky top-0 bg-slate-950/90 backdrop-blur z-10">
        <div className="max-w-5xl mx-auto px-6 py-4 flex items-center gap-3">
          {b.logo_url ? <img src={b.logo_url} alt={b.company_name} className="h-10" /> : (
            <><div className="w-10 h-10 rounded-xl flex items-center justify-center" style={{ background: color }}><i className="fa-solid fa-solar-panel text-slate-950" /></div>
            <div><p className="font-bold text-lg">{b.company_name}</p><p className="text-xs text-slate-400">Careers</p></div></>
          )}
          <a href="/" className="ml-auto text-xs text-slate-400 hover:text-white">← samaritansolar.customcoded.pro</a>
        </div>
      </header>

      <div className="relative overflow-hidden">
        {b.hero_image_url && <div className="absolute inset-0"><img src={b.hero_image_url} alt="" className="w-full h-full object-cover opacity-25" /><div className="absolute inset-0 bg-gradient-to-t from-slate-950 to-slate-950/40" /></div>}
        <div className="relative max-w-5xl mx-auto px-6 py-16">
          <p className="text-xs font-bold tracking-widest uppercase" style={{ color }}>We're hiring closers & canvassers</p>
          <h1 className="text-4xl font-black tracking-tight mt-2">{b.headline}</h1>
          {b.tagline && <p className="text-slate-300 mt-3 max-w-2xl">{b.tagline}</p>}
          {jobs && jobs.length > 0 && <p className="text-sm text-slate-400 mt-4" data-testid="careers-count">{jobs.length} open {jobs.length === 1 ? 'role' : 'roles'} — applications reviewed within 48 hours</p>}

          {(b.photos || []).length > 0 && (
            <div className="flex gap-3 mt-8 overflow-x-auto pb-2">
              {b.photos.map((p, i) => <img key={i} src={p} alt="" className="h-28 w-40 object-cover rounded-xl flex-shrink-0" />)}
            </div>
          )}

          <div className="mt-10 grid sm:grid-cols-2 gap-4">
            {jobs === null && <p className="text-slate-500">Loading roles…</p>}
            {jobs && jobs.length === 0 && <p className="text-slate-500">No open roles right now — check back soon.</p>}
            {jobs && jobs.map(j => (
              <Link key={j.slug} to={`/careers/${j.slug}${window.location.search}`} className="block bg-slate-900 border border-slate-800 rounded-2xl p-6 hover:border-white/30 transition-all group" style={{ '--hover': color }} data-testid="career-job-card">
                <div className="flex items-start justify-between">
                  <h2 className="text-lg font-bold transition-colors" style={{ color: 'inherit' }}>{j.title}</h2>
                  <i className="fa-solid fa-arrow-right text-slate-600 group-hover:translate-x-1 transition-transform" style={{ color }} />
                </div>
                <p className="text-sm text-slate-400 mt-1">{j.location || j.market} · {j.employment_type}</p>
                {j.compensation_public?.ote_low ? <p className="text-sm font-semibold mt-3" style={{ color }}>OTE ${j.compensation_public.ote_low.toLocaleString()} – ${j.compensation_public.ote_high.toLocaleString()}/yr</p> : null}
                <p className="text-xs font-semibold mt-3 text-slate-300">View role & apply →</p>
              </Link>
            ))}
          </div>

          <div className="mt-12 bg-slate-900 border border-slate-800 rounded-2xl p-6" data-testid="careers-referral">
            <p className="font-bold">Know a killer closer?</p>
            <p className="text-sm text-slate-400 mt-1">Send them any role above — applications take 2 minutes and every one gets read by a human within 48 hours.</p>
          </div>
        </div>
      </div>
    </div>
  );
}
